import defaultReducer from "./defaultReducer";

export const customerTabReducer = defaultReducer("CUSTOMER_TAB", {
  activeIndex: 0,
  activeViewTab: null,
  hideViewTab: false,
  hideDetails: false,

  // Customer Tab Filters
  customerName: "",
  reviewStatusIds: [3, 4],
  reviewStatusCounts: null,
  customerLastUpdatedFrom: null,
  customerLastUpdatedTo: null,
  showExtraFilters: false,
  selectedCustomerState: null,
  customerStatusTypes: null,

  // Customer Tab Table
  pageNumber: 1,
  totalRecords: 0,
  detailsPageNumber: 1,
  detailsTotalRecords: 0,
  headings: [
    { name: "Review Status", value: "ReviewStatus" },
    { name: "Customer State", value: "CustomerState" },
    { name: "Name", value: "CustomerName" },
    { name: "Interaction Count", value: "InteractionCount" },
    { name: "Latest Risk Score", value: "LatestRiskScore" },
    { name: "Average Risk Score", value: "CumulativeRiskScore" },
    { name: "Primary Site", value: "SiteName" },
    { name: "Customer ID", value: "CustomerId" },
    { name: "Customer Created", value: "CustomerCreated" },
  ],
  records: null,
  customerEvents: null,
  customerSessions: null,
  customerReviews: null,
  selectedCustomer: null,
  selectedReview: null,

  // Customer details
  customerStatus: null,
});
